import { useEffect, useMemo, useState } from "react";

import { paths } from "src/routes/paths";

import { useTranslate } from "src/locales";

import Label from "src/components/label";

import { useAuthContext } from "src/auth/hooks";
import { useGetProviderSettingsGlobals } from "src/api/provider";
import { getOrganiserNav } from "./admintypenavs/organiserNav";
import { ICONS, settingIcon } from "./admintypenavs/menuIcons";
import { getFacilityNav } from "./admintypenavs/facilityNav";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useTranslate();
  const { currentProviderType } = useAuthContext();

  const data = useMemo(
    () => {
      if (
        currentProviderType === "undefined" ||
        currentProviderType === undefined ||
        currentProviderType === "facility" ||
        currentProviderType === "coach"
      ) {
        return getFacilityNav();
      } else if (currentProviderType === "organiser") {
        // NAVIGATION FOR TOURNAMENT PROVIDER
        return getOrganiserNav(currentProviderType); // 👈 uses the extracted file
      }

      return [];
    },
    //[venueMenu, t]
    [t, currentProviderType]
  );

  return data;
}

/*-------------------------------------------------*/
// const { globalsettings, globalsettingsLoading, globalsettingsError } =
//   useGetProviderSettingsGlobals(currentProvider);

// const [venueBased, setVenueBased] = useState();

// useEffect(() => {
//   if (globalsettings) {
//     setVenueBased(
//       globalsettings.find(
//         (setting: any) => setting.name === "calendarviewtype"
//       )?.value
//     );
//   }
// }, [globalsettings]);

// const venueMenu =
//   venueBased === "venue-based"
//     ? {
//         title: t("venue"),
//         path: paths.dashboard.settings.venue.root,
//       }
//     : null;
// {
//   subheader: t("profilesettings"),
//   items: [
//     {
//       title: t("profile_data"),
//       path: paths.dashboard.profile.root,
//       icon: ICONS.file,
//       children: [
//         {
//           title: t("profile"),
//           path: paths.dashboard.profile.data,
//         },
//         { title: t("images"), path: paths.dashboard.profile.images },
//         { title: t("sports"), path: paths.dashboard.profile.sports },
//         { title: t("venues"), path: paths.dashboard.profile.venues },

//         {
//           title: t("billing_infos"),
//           path: paths.dashboard.profile.billing_infos,
//         },
//         // { title: t("staff"), path: paths.dashboard.profile.staff },
//       ],
//     },
//   ],
// },

// {
//   subheader: t("test"),
//   items: [
//     // USER
//     {
//       title: t("user"),
//       path: paths.dashboard.user.root,
//       icon: ICONS.user,
//       children: [
//         { title: t("profile"), path: paths.dashboard.user.root },
//         { title: t("cards"), path: paths.dashboard.user.cards },
//         { title: t("list"), path: paths.dashboard.user.list },
//         { title: t("create"), path: paths.dashboard.user.new },
//         { title: t("edit"), path: paths.dashboard.user.demo.edit },
//         { title: t("account"), path: paths.dashboard.user.account },
//       ],
//     },
//     {
//       title: t("product"),
//       path: paths.dashboard.product.root,
//       icon: ICONS.product,
//       children: [
//         { title: t("list"), path: paths.dashboard.product.root },
//         {
//           title: t("details"),
//           path: paths.dashboard.product.demo.details,
//         },
//         { title: t("create"), path: paths.dashboard.product.new },
//         { title: t("edit"), path: paths.dashboard.product.demo.edit },
//       ],
//     },
//   ],
// },

// MANAGEMENT
// ----------------------------------------------------------------------
// {
//   subheader: t("management"),
//   items: [
//     // USER
//     {
//       title: t("user"),
//       path: paths.dashboard.user.root,
//       icon: ICONS.user,
//       children: [
//         { title: t("profile"), path: paths.dashboard.user.root },
//         { title: t("cards"), path: paths.dashboard.user.cards },
//         { title: t("list"), path: paths.dashboard.user.list },
//         { title: t("create"), path: paths.dashboard.user.new },
//         { title: t("edit"), path: paths.dashboard.user.demo.edit },
//         { title: t("account"), path: paths.dashboard.user.account },
//       ],
//     },

//     // PRODUCT
// {
//   title: t("product"),
//   path: paths.dashboard.product.root,
//   icon: ICONS.product,
//   children: [
//     { title: t("list"), path: paths.dashboard.product.root },
//     {
//       title: t("details"),
//       path: paths.dashboard.product.demo.details,
//     },
//     { title: t("create"), path: paths.dashboard.product.new },
//     { title: t("edit"), path: paths.dashboard.product.demo.edit },
//   ],
// },

//     // ORDER
//     {
//       title: t("order"),
//       path: paths.dashboard.order.root,
//       icon: ICONS.order,
//       children: [
//         { title: t("list"), path: paths.dashboard.order.root },
//         { title: t("details"), path: paths.dashboard.order.demo.details },
//       ],
//     },

//     // INVOICE
//     {
//       title: t("invoice"),
//       path: paths.dashboard.invoice.root,
//       icon: ICONS.invoice,
//       children: [
//         { title: t("list"), path: paths.dashboard.invoice.root },
//         {
//           title: t("details"),
//           path: paths.dashboard.invoice.demo.details,
//         },
//         { title: t("create"), path: paths.dashboard.invoice.new },
//         { title: t("edit"), path: paths.dashboard.invoice.demo.edit },
//       ],
//     },

//     // BLOG
//     {
//       title: t("blog"),
//       path: paths.dashboard.post.root,
//       icon: ICONS.blog,
//       children: [
//         { title: t("list"), path: paths.dashboard.post.root },
//         { title: t("details"), path: paths.dashboard.post.demo.details },
//         { title: t("create"), path: paths.dashboard.post.new },
//         { title: t("edit"), path: paths.dashboard.post.demo.edit },
//       ],
//     },

//     // JOB
//     {
//       title: t("job"),
//       path: paths.dashboard.job.root,
//       icon: ICONS.job,
//       children: [
//         { title: t("list"), path: paths.dashboard.job.root },
//         { title: t("details"), path: paths.dashboard.job.demo.details },
//         { title: t("create"), path: paths.dashboard.job.new },
//         { title: t("edit"), path: paths.dashboard.job.demo.edit },
//       ],
//     },

//     // TOUR
//     {
//       title: t("tour"),
//       path: paths.dashboard.tour.root,
//       icon: ICONS.tour,
//       children: [
//         { title: t("list"), path: paths.dashboard.tour.root },
//         { title: t("details"), path: paths.dashboard.tour.demo.details },
//         { title: t("create"), path: paths.dashboard.tour.new },
//         { title: t("edit"), path: paths.dashboard.tour.demo.edit },
//       ],
//     },

//     // FILE MANAGER
//     {
//       title: t("file_manager"),
//       path: paths.dashboard.fileManager,
//       icon: ICONS.folder,
//     },

//     // MAIL
//     {
//       title: t("mail"),
//       path: paths.dashboard.mail,
//       icon: ICONS.mail,
//       info: <Label color="error">+32</Label>,
//     },

//     // CHAT
//     // {
//     //   title: t('chat'),
//     //   path: paths.dashboard.chat,
//     //   icon: ICONS.chat,
//     // },

//     // CALENDAR
//     {
//       title: t("calendar"),
//       path: paths.dashboard.calendar,
//       icon: ICONS.calendar,
//     },

//     // KANBAN
//     {
//       title: t("kanban"),
//       path: paths.dashboard.kanban,
//       icon: ICONS.kanban,
//     },
//   ],
// },

// // DEMO MENU STATES
// {
//   subheader: t(t("other_cases")),
//   items: [
//     {
//       // default roles : All roles can see this entry.
//       // roles: ['user'] Only users can see this item.
//       // roles: ['admin'] Only admin can see this item.
//       // roles: ['admin', 'manager'] Only admin/manager can see this item.
//       // Reference from 'src/guards/RoleBasedGuard'.
//       title: t("item_by_roles"),
//       path: paths.dashboard.permission,
//       icon: ICONS.lock,
//       roles: ["admin", "manager"],
//       caption: t("only_admin_can_see_this_item"),
//     },
//     {
//       title: t("menu_level"),
//       path: "#/dashboard/menu_level",
//       icon: ICONS.menuItem,
//       children: [
//         {
//           title: t("menu_level_1a"),
//           path: "#/dashboard/menu_level/menu_level_1a",
//         },
//         {
//           title: t("menu_level_1b"),
//           path: "#/dashboard/menu_level/menu_level_1b",
//           children: [
//             {
//               title: t("menu_level_2a"),
//               path: "#/dashboard/menu_level/menu_level_1b/menu_level_2a",
//             },
//             {
//               title: t("menu_level_2b"),
//               path: "#/dashboard/menu_level/menu_level_1b/menu_level_2b",
//               children: [
//                 {
//                   title: t("menu_level_3a"),
//                   path: "#/dashboard/menu_level/menu_level_1b/menu_level_2b/menu_level_3a",
//                 },
//                 {
//                   title: t("menu_level_3b"),
//                   path: "#/dashboard/menu_level/menu_level_1b/menu_level_2b/menu_level_3b",
//                 },
//               ],
//             },
//           ],
//         },
//       ],
//     },
//     {
//       title: t("item_disabled"),
//       path: "#disabled",
//       icon: ICONS.disabled,
//       disabled: true,
//     },
//     {
//       title: t("item_label"),
//       path: "#label",
//       icon: ICONS.label,
//       info: (
//         <Label
//           color="info"
//           startIcon={<Iconify icon="solar:bell-bing-bold-duotone" />}
//         >
//           NEW
//         </Label>
//       ),
//     },
//     {
//       title: t("item_caption"),
//       path: "#caption",
//       icon: ICONS.menuItem,
//       caption:
//         "Quisque malesuada placerat nisl. In hac habitasse platea dictumst. Cras id dui. Pellentesque commodo eros a enim. Morbi mollis tellus ac sapien.",
//     },
//     {
//       title: t("item_external_link"),
//       path: "https://www.google.com/",
//       icon: ICONS.external,
//     },
//     {
//       title: t("blank"),
//       path: paths.dashboard.blank,
//       icon: ICONS.blank,
//     },
//   ],
// },
